import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "../trpc";
import { getQueryKey } from "@trpc/react-query";
import type { AuthenticationsOutput } from "@zapier/bff";

export function useRenameAuthentication() {
  const queryClient = useQueryClient();

  const authenticationsKey = getQueryKey(
    trpc.authentication.authentications,
    undefined,
    "any",
  );

  const mutation = trpc.authentication.rename.useMutation({
    // Callback to handle optimistic updates in RQ cache
    onMutate: ({ name, id }) => {
      if (!id) {
        return;
      }

      // Update Authentication under the authentications list key
      queryClient.cancelQueries({ queryKey: authenticationsKey });
      queryClient.setQueriesData(
        {
          queryKey: authenticationsKey,
          type: "active",
        },
        (old: AuthenticationsOutput | undefined) => {
          if (old?.results) {
            const updatedAuthenticationsArray = old?.results.map((item) =>
              item.id === id ? { ...item, title: name } : item,
            );

            // this needs to return a new object ref for RQ to detect the change
            return {
              ...old,
              results: updatedAuthenticationsArray,
            };
          }

          return old;
        },
      );
    },
    // Callback to handle cache invalidation after mutation is completed
    onSettled: () => {
      // Invalidate authentications key to refetch data
      queryClient.invalidateQueries({ queryKey: authenticationsKey });
    },
  });

  return {
    rename: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
